import React from 'react'
import { connect } from 'react-redux'
import PoseList from './PoseList'
import Filters from './Filters';

const Dashboard = (props) => {
  return (
    <div>
      <Filters />
      <PoseList />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth
  }
}

export default connect(mapStateToProps)(Dashboard)
